import { useProgressPercentEffect } from "@Roo/RegistrationNew/Components/Common/hooks/useProgressPercentEffect";
import { REGISTRATION_PROGRESS_PERCENT } from "@Roo/RegistrationNew/Components/Common/service";
import { MeetYourRep } from "@Roo/RegistrationNew/Components/RegistrationMeetYourRooRep/MeetYourRep";
import React from "react";

interface LowCommitmentMeetYourRepProps {
  handleScheduleCall: () => void;
}
export const LowCommitmentMeetYourRep = ({ handleScheduleCall }: LowCommitmentMeetYourRepProps) => {
  useProgressPercentEffect(REGISTRATION_PROGRESS_PERCENT.MeetRooRep);

  return <MeetYourRep handleScheduleCall={handleScheduleCall} />;
};
